<template>
  <v-container grid-list-xl class="pa-5">
    <v-alert v-if="is_premium" dense text class="body-2 mb-5" type="info">
      Halaman ini menampilkan <strong>profil pengguna</strong> yang pernah terindikasi kecurangan. Anda bisa memfilter
      data pada periode tertentu untuk melihat siapa yang pernah melakukan kecurangan pada periode tersebut.
    </v-alert>

    <m-card-list
      two-line
      title="Profil Kecurangan Pengguna"
      label-cari="Cari nama pengguna..."
      search
      :items="items"
      :headers="headers"
      refresh
      @refresh="load"
      :page="page"
      footer
      @search="
        (search) => {
          textSearch = search
          cp = 1
          load()
        }
      "
      @change:page="
        (pg) => {
          cp = pg
          load()
        }
      "
    >
      <template v-slot:action_tools>
        <div class="d-flex align-center justify-space-between flex-wrap filter-wrap mr-2">
          <div class="d-flex align-center flex-wrap filter-actions">
            <v-menu
              ref="dateRangeMenu"
              v-model="dateRangeMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateRangeText"
                  label="Rentang Tanggal"
                  prepend-icon="mdi-calendar"
                  readonly
                  clearable
                  dense
                  outlined
                  hide-details
                  class="date-range-filter"
                  v-on="on"
                  @click:clear="resetDateFilter"
                />
              </template>
              <v-date-picker v-model="dates" no-title scrollable locale="id" range color="primary">
                <v-spacer />
                <v-btn depressed text color="primary" @click="dateRangeMenu = false">Cancel</v-btn>
                <v-btn depressed text color="primary" @click="applyDateFilter">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </template>

      <template v-slot:items="{ item }">
        <tr v-if="$vuetify.breakpoint.smAndUp">
          <td class="py-3 px-4">
            <div class="d-flex align-center">
              <v-avatar :size="40" color="grey lighten-4" class="mr-3">
                <v-img :src="avatarSrc(item)" alt="avatar" />
              </v-avatar>
              <div>
                <div class="body-2">{{ pVal(item, 'nama') }}</div>
              </div>
            </div>
          </td>
          <td class="py-3 px-4 font-weight-medium text--secondary"> {{ instansiName(item) }} </td>
          <td class="py-3 px-4 text-right">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab x-small depressed color="primary" @click="openDetail(item)">
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Lihat detail profil</span>
            </v-tooltip>
          </td>
        </tr>
        <tr v-else>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[0].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              <div class="d-flex align-center justify-end">
                <v-avatar :size="34" color="grey lighten-4" class="mr-2">
                  <v-img :src="avatarSrc(item)" alt="avatar" />
                </v-avatar>
                <div class="text-right">
                  <div class="font-weight-bold">{{ pVal(item, 'nama') }}</div>
                  <div class="text-caption text--secondary">Pengguna</div>
                </div>
              </div>
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[1].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ instansiName(item) }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[2].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              <v-btn x-small rounded depressed color="primary" class="text-none" @click="openDetail(item)">
                <v-icon x-small left>mdi-eye</v-icon>
                Detail
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </m-card-list>

    <DetailDialog v-model="detailDialog" :detail="detail" :dates="dates" />
  </v-container>
</template>

<script>
import DetailDialog from '@/modules/profilKecuranganPengguna/components/DetailDialog.vue'

export default {
  components: {
    DetailDialog,
  },
  data() {
    return {
      rawItems: [],
      textSearch: null,
      page: null,
      cp: 1,
      detailDialog: false,
      detail: null,
      dates: [],
      dateRangeMenu: false,
      headers: [
        { text: 'Nama Pengguna', align: 'left', value: 'nama', width: '58%' },
        { text: 'Nama Instansi', align: 'left', value: 'instansi', width: '32%' },
        { text: 'Detail', align: 'right', value: 'detail', sortable: false, width: '10%' },
      ],
    }
  },
  computed: {
    normalizedDateRange() {
      return [...this.dates].sort()
    },
    filterStartDate() {
      return this.normalizedDateRange[0] || null
    },
    filterEndDate() {
      return this.normalizedDateRange[1] || this.filterStartDate
    },
    dateRangeText() {
      if (this.normalizedDateRange.length === 1) return this.formatDate(this.filterStartDate)
      return this.normalizedDateRange.map((date) => this.formatDate(date)).join(' — ')
    },
    hasDateFilter() {
      return Boolean(this.dates.length)
    },
    items() {
      return this.rawItems
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$store
        .dispatch('profilKecuranganPengguna/get', {
          tenant_id: this.tenant_id,
          params: {
            page: this.cp,
            keyword: this.textSearch,
            tgl_awal: this.filterStartDate,
            tgl_akhir: this.filterEndDate,
          },
        })
        .then((res) => {
          this.page = res.data
          this.rawItems = res.data.data
        })
        .catch((e) => e)
    },
    applyDateFilter() {
      this.$refs.dateRangeMenu.save(this.dates)
      this.cp = 1
      this.load()
    },
    resetDateFilter() {
      this.dates = []
      this.dateRangeMenu = false
      this.cp = 1
      this.load()
    },
    formatDate(date) {
      if (!date) return '-'
      return this.$options.filters.toSDN(date)
    },
    avatarSrc(item) {
      return item && item.gender === 'P' ? 'img/cewek.png' : 'img/cowok.png'
    },
    instansiName(item) {
      return item && item.organisasi && item.organisasi.nama ? item.organisasi.nama : '-'
    },
    openDetail(item) {
      this.detail = item
      this.detailDialog = true
    },
  },
}
</script>

<style scoped>
.filter-wrap {
  gap: 16px;
}

.filter-actions {
  gap: 10px;
}

.date-range-filter {
  width: 260px;
}

.date-range-filter ::v-deep .v-input__prepend-outer {
  margin-right: 6px;
}

.date-range-filter ::v-deep .v-input__slot {
  min-height: 38px !important;
}

.date-range-filter ::v-deep input {
  font-size: 13px;
}

.reset-filter-btn {
  height: 32px !important;
}
</style>
